import Home from "./components/Home.vue"
import Sobre from "./components/Sobre.vue"
import NFS from "./components/NFS.vue"
import Personalizadas from "./components/Personalizadas.vue"
import Pergamin from "./components/Pergamin.vue"
import Contato from "./components/Contato.vue"

export const routes = [
    { path: '', component: Home, name: 'Home' },
    { path: '/sobre', component: Sobre, name: 'Sobre' },
    { path: '/nfs', component: NFS, name: 'NFS' },
    { path: '/pergamin', component: Pergamin, name: 'Pergamin' },
    { path: '/personalizadas', component: Personalizadas, name: 'Personalizadas' },
    { path: '/contato', component: Contato, name: 'Contato' },
  ];